import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from "environments/environment";

@Injectable()
export class ExampleService {

    private _apiUrl = environment.apiUrl;
    private _httpClient = inject(HttpClient);

    getJetPlanes() {
        return this._httpClient.get(`${this._apiUrl}/v1/example/get-jet-planes`);
    }
    getJetPlanesNotesById(id: number) {
        return this._httpClient.get(`${this._apiUrl}/v1/example/get-jet-planes-notes-by-id/${id}`);
    }

    getFilteredNotes(queryParam: any) {

        let params = new HttpParams();

        for (const key in queryParam) {
            params = params.append(key, queryParam[key]);
        }

        const options = {
            params,
        };

        return this._httpClient.get(`${this._apiUrl}/v1/notes/get-filtered`, options);
    }
}
